module.exports = __webpack_public_path__ + "images/categories-13937757.svg";